import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'sa-ui';

import './ReportResultCard.scss';

const ReportResultCard = props => (
  <Card className="general-result-card" style={{minHeight: props.cardTRI ? '210px' : 'auto'}}>
    <div style={{textTransform: props.cardTRI ? "uppercase" : "inherit"}}>{props.label}</div>
    <div>
      <h2>{props.value}</h2>
    </div>
  </Card>
);

ReportResultCard.propTypes = {};

ReportResultCard.defaultProps = {
  value: 0,
};

export default ReportResultCard;
